'use client'

import { PropsWithChildren } from 'react';

interface CardBoxFidelityProps {
  step: string;
  description: string;
}

const CardBoxFidelity = ({step, description}: PropsWithChildren<CardBoxFidelityProps>) => {
  return (
    <div className="md:relative bg-white rounded-2xl p-4 md:p-8 md:pt-10 gap-4 shadow-md md:shadow-lg ring-1 ring-gray-100 flex md:flex-col items-center md:text-center">
        <div className="md:absolute md:-top-7 md:left-1/2 md:-translate-x-1/2 w-12 h-12 md:w-12 md:h-12 aspect-square rounded-full bg-white ring-2 ring-custom-primary text-custom-primary flex items-center justify-center text-2xl md:text-3xl font-extrabold transition-all ease-in-out">
            {step}
        </div>
        <p className="text-shopfood-title md:text-lg leading-none md:leading-none" dangerouslySetInnerHTML={{ __html: description }} />
    </div>
  )
}

export default CardBoxFidelity;